const emailRegExp =
  /^(([^<>()[\]=.,;:\s@'"]+(\.[^<>()[\]=.,;:\s@'"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;

export { emailRegExp };
